export default __webpack_public_path__ + "static/Community newsletter - June 2021-d8ed4b98636d565077c81c38c098f715.pdf";